import {mapActions, mapGetters, mapMutations} from 'vuex'

export const fontMixin = {
  computed: {
    ...mapGetters({
      'fonts': 'fonts/all'
      // 'font': 'fonts/font'
    })
  },
  methods: {
    ...mapActions({
      'getFonts': 'fonts/getFonts',
      'addSingleFont': 'fonts/addFont'
    }),
    ...mapMutations({
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/fontMixin.js